import { Injectable } from '@angular/core';
import {GroovePlanApiService} from "../grooveplan-api.service";
import {HttpClient} from "@angular/common/http";
import {StorageService} from "../internals/storage.service";
import {Router} from "@angular/router";
import { ProcurationModel } from 'src/app/models/procuration.model';
import { UserService } from './user.service';
import { SecureStorageService } from '../internals/secure-storage.service';

@Injectable({
  providedIn: 'root'
})
export class ProcurationService extends GroovePlanApiService {

  constructor(_httpClient: HttpClient,
              storageService: StorageService,
              secureStorage: SecureStorageService,
              router: Router,
              private userService: UserService
            ) {
    super(_httpClient, storageService, secureStorage, router)
    this.entityUrl = new ProcurationModel().getEntityUrl();
  }
  /**
   * @description
   * Get all procurations
   * @returns {Observable<ProcurationModel[]>}
   */
  async getProcurations() {
    const currentUser = await this.userService.getUserInStorage();
    return this.findBy({
      mandataire: currentUser?.id,
    });
  }

  /**
   * @description
   * Get all procurations of current user for a given group
   * @param {number} groupe_id
   * @returns {Observable<ProcurationModel[]>}
   */
  async getProcurationsGroupe(groupe_id: number) {
    let headers = await this.getAuthHeaders()
    return this.get(this.entityUrl + '/groupe/' + groupe_id, headers);
  }
}